import { v4 as uuidv4 } from 'uuid';

import { dispatchPromise, fetchResources } from './action-helpers';

import { getCurrentUser } from '../services/store-service';

const DEFAULT_RULE_PROPS = {
    id: null,
    task: null,
    type: 'date',
    trigger: null,
    schedule: null,
    till: null,
    cron: null,
    bi_weekly: 0
};

export const fetchRecursionRules = (projectId: string, all) => fetchResources('RECURSION_RULES_FETCH_REQUESTED', { projectId }, all);

export const createRecursionRule = ruleProps => {
    const currentUser = getCurrentUser();
    return dispatchPromise({
        type: 'RECURSION_RULE_CREATE_REQUESTED',
        payload: {
            rule: Object.assign({}, DEFAULT_RULE_PROPS, ruleProps, {
                id: uuidv4(),
                tz_offset: currentUser.tz_offset,
                tz_iana: currentUser.tz_iana
            })
        }
    });
}

export const fetchRecursionRule = ruleId => {
    return dispatchPromise({
        type: 'RECURSION_RULE_FETCH_REQUESTED',
        payload: { ruleId }
    });
}

export const updateRecursionRule = (ruleId, ruleProps, preventSave) => {
    return dispatchPromise({
        type: 'RECURSION_RULE_UPDATE_REQUESTED',
        preventSave,
        payload: {
            ruleId,
            ruleProps
        }
    });
}

export const removeRecursionRule = ruleId => {
    return dispatchPromise({
        type: 'RECURSION_RULE_REMOVE_REQUESTED',
        payload: {
            ruleId
        }
    });
}
